const VideoController = () => {
  const initVideoController = container => {
    if (!container || !(container instanceof Element)) {
      console.error('Invalid container passed to VideoController');
      return null;
    }

    const ctrl = {
      video: null,
      playing: false,
      muted: false,
      seekPosition: 0,
      container,
      data: {},
      target: false,
      seeking: false,

      controls: {
        mute: null,
        unmute: null,
        seek: null,
        pause: null,
        play: null,
      },

      init() {
        this.data = Object.fromEntries(Object.entries(this.container.dataset).map(([key, value]) => [key, value]));
        this.video = document.querySelector(this.data.target);
        if (!this.video) {
          console.error('Video element not found');
          return;
        }

        this.controls.mute = this.container.querySelector('[btn-mute]');
        this.controls.unmute = this.container.querySelector('[btn-unmute]');
        this.controls.seek = this.container.querySelector('[btn-seek]');
        this.controls.pause = this.container.querySelector('[btn-pause]');
        this.controls.play = this.container.querySelector('[btn-play]');

        this.controls.mute?.addEventListener('click', this.mute.bind(this));
        this.controls.unmute?.addEventListener('click', this.unmute.bind(this));
        this.controls.play?.addEventListener('click', this.play.bind(this));
        this.controls.pause?.addEventListener('click', this.pause.bind(this));
        this.controls.seek?.addEventListener('mousedown', this.startSeekVideo.bind(this));
        this.controls.seek?.addEventListener('mouseup', this.seekVideo.bind(this));
        if (this.controls.seek) this.controls.seek.value = 0;

        this.video.addEventListener('canplay', () => {
          if (this.video.muted) {
            this.container.classList.add('muted');
          }
        });
        this.video.addEventListener('play', () => this.container.classList.add('playing'));
        this.video.addEventListener('ended', () => this.container.classList.add('playing'));

        this.video.addEventListener('timeupdate', () => {
          if (!this.seeking && this.controls.seek) {
            const value = (100 / this.video.duration) * this.video.currentTime;
            this.controls.seek.value = value;
          }
        });
      },

      play() {
        this.video?.play();
        this.playing = true;
        this.container.classList.add('playing');
      },

      pause() {
        this.video?.pause();
        this.playing = false;
        this.container.classList.remove('playing');
      },

      mute() {
        if (this.video) {
          this.video.muted = true;
          this.container.classList.add('muted');
        }
      },

      unmute() {
        if (this.video) {
          this.video.muted = false;
          this.container.classList.remove('muted');
        }
      },

      seekVideo() {
        if (this.video && this.controls.seek) {
          const time = this.video.duration * (this.controls.seek.value / 100);
          this.video.currentTime = time;
        }
        this.seeking = false;
      },

      startSeekVideo() {
        this.seeking = true;
      },
    };

    ctrl.init();
    return ctrl;
  };

  const videoControlElements = document.querySelectorAll('[mx-video-controls]');

  if (videoControlElements.length > 0) {
    videoControlElements.forEach(element => {
      initVideoController(element);
    });
  }
};

export default VideoController;